<template>
  <div class="profile">
    <div class="profile-container">
      <!-- 公司介绍 -->
      <div class="company-intro">
        <h2>公司简介</h2>
        <div class="intro-content">
          <p>杭州坤时自动化系统有限公司成立于2003年，专注自动化领域20多年，是一家集研发、生产、销售、安装、调试、售后服务一体化的国家级高新技术企业。作为智能制造行业的领跑者，业务涵盖锂电池后段化成分容先进解决方案、工业自动化系统、光伏领域解决方案、智能软件系统等。</p>
          <p>公司在深圳光明、东莞塘厦建设有约15万平米的两大生产制造基地，现有员工1000余人，其中设计研发团队400余人。并拥有来自华为、中兴和大疆的高管团队，毕业于985名校的一流人才，以及负责机械、电控、软件三大核心专家研发团队，全面推动公司高质量发展。</p>
          <p>目前业务已渗透到全球，并和宁德时代、比亚迪、LG、中创新航、瑞浦兰钧、蜂巢能源、亿纬锂能、楚能新能源、鹏辉能源、正力新能、欣旺达、力神电池、华星光电、安世半导体、K&S等龙头企业建立了深厚信任和长期合作关系。</p>
        </div>
      </div>

      <!-- 核心数据 -->
      <div class="core-data">
        <div class="data-item">
          <div class="number">2003</div>
          <div class="unit">年</div>
          <div class="label">公司成立</div>
        </div>
        <div class="data-item">
          <div class="number">150000</div>
          <div class="unit">㎡</div>
          <div class="label">制造基地</div>
        </div>
        <div class="data-item">
          <div class="number">1000</div>
          <div class="unit">+</div>
          <div class="label">全球员工</div>
        </div>
        <div class="data-item">
          <div class="number">100</div>
          <div class="unit">+</div>
          <div class="label">合作伙伴</div>
        </div>
      </div>

      <!-- 企业理念 -->
      <div class="company-philosophy">
        <h3>追求技术创新为主导 满足客户需求为己任</h3>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProfileView'
}
</script>

<style lang="scss" scoped>
.profile {
  padding: 60px 0;
  background: #fff;

  .profile-container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 20px;

    .company-intro {
      margin-bottom: 60px;

      h2 {
        font-size: 36px;
        color: #333;
        margin-bottom: 30px;
        text-align: center;
        position: relative;

        &::after {
          content: '';
          position: absolute;
          bottom: -15px;
          left: 50%;
          transform: translateX(-50%);
          width: 60px;
          height: 3px;
          background: #409EFF;
        }
      }

      .intro-content {
        p {
          font-size: 16px;
          line-height: 1.8;
          color: #666;
          margin-bottom: 20px;
          text-align: justify;
        }
      }
    }

    .core-data {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 30px;
      margin-bottom: 60px;
      padding: 40px 0;
      background: #f8f9fa;
      border-radius: 8px;

      .data-item {
        text-align: center;
        padding: 20px;

        .number {
          font-size: 48px;
          font-weight: bold;
          color: #409EFF;
          line-height: 1;
          margin-bottom: 5px;
        }

        .unit {
          font-size: 24px;
          color: #409EFF;
          display: inline-block;
          margin-left: 5px;
        }

        .label {
          font-size: 18px;
          color: #666;
          margin-top: 10px;
        }
      }
    }

    .company-philosophy {
      text-align: center;
      padding: 40px 0;
      background: #f8f9fa;
      border-radius: 8px;

      h3 {
        font-size: 24px;
        color: #333;
        font-weight: 500;
      }
    }
  }
}

@media (max-width: 768px) {
  .profile {
    .profile-container {
      .core-data {
        grid-template-columns: repeat(2, 1fr);
      }
    }
  }
}
</style> 